module.exports = __webpack_public_path__ + "img/9788958071853.c5909331.jpg";